import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertComponent } from 'src/app/layout/extensions/alert/alert.component';
import { ConstantAlertBtn, ConstantAlertMsg } from 'src/app/utils/common/constant-alert-msg';
import { ConstantAlertType } from 'src/app/utils/common/constant-alert-type';
import { ListPartnerVerification } from 'src/app/utils/models/aas-models/partner/partner-verification/list-partner-verification/list-partner-verification';
import { ListPartnerConsumer } from 'src/app/utils/models/aas-models/partner/partner-verification/list-partner-verification/list-partner-consumer';
import { AasAuthService } from 'src/app/utils/services/aas-network/aas-auth.service';
import { PartnerService } from 'src/app/utils/services/aas-network/partner.service';
import { AuthService } from 'src/app/utils/services/auth.service';
import { PartnerConsumer } from 'src/app/utils/models/aas-models/partner/partner-verification/partner-consumer/partner-consumer';
import { ValidateMessage } from 'src/app/utils/common/validate-msg-aas';
import { PARTNER_DENY_FORM } from 'src/app/utils/common/constant-vaildate-msg';
import { ResponseMsg } from 'src/app/utils/common/response-msg-aas';
import { ListPartnerBusiness } from 'src/app/utils/models/aas-models/partner/partner-verification/list-partner-verification/list-partner-business';
import { ListPartnerBusinessVerification } from 'src/app/utils/models/aas-models/partner/partner-verification/list-partner-verification/list-partner-business-verification';
import { PartnerBusiness } from 'src/app/utils/models/aas-models/partner/partner-verification/partner-business/partner-business';
import { AasContractService } from 'src/app/utils/services/aas-network/aas-contract.service';
import { EncodeService } from 'src/app/utils/common/encode-service';
import { ContractFileInfo } from 'src/app/utils/models/aas-models/contract/contract-file/contract-file.model';
import { ContractEncode } from 'src/app/utils/common/contract-encode';
import { AlertControl } from 'src/app/utils/alert/alert-control';
import { localize } from 'src/app/utils/localize/localize';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-approved-party-partner',
  templateUrl: './approved-party-partner.component.html',
  styleUrls: ['./approved-party-partner.component.scss']
})
export class ApprovedPartyPartnerComponent implements OnInit {
  @ViewChild('rejectContent') public rejectContent: TemplateRef<any>;
  @ViewChild('calling') public calling: TemplateRef<any>;
  @ViewChild('approve') public approve: TemplateRef<any>;

  default_ava_img: string = 'assets/img/services/user-incall-ava-default.png';
  ava_img: string = '';
  
  searchForm: FormGroup;
  denyForm: FormGroup;
  isSubmitDenyForm: boolean = false;
  validateDenyMsg: any = PARTNER_DENY_FORM;

  verificationStatus: string = 'APPROVE';
  // searchString: string = '';
  page: number = 1;
  maxSize: number = 5;
  userType: string = 'BUSINESS';
  totalElement: number = 0;

  partners: ListPartnerBusiness[] = [];
  partner: PartnerBusiness = new PartnerBusiness();
  partnerVerificationId: string = '';
  fileGPKD: Blob = null;
  showPreviewGPKD: boolean = false;

  imgFront: string = '';
  imgBack: string = '';
  imgFace: string = '';

  modalReject: any = null;

  gender = ["WaitPartyPartner_agent_gender_0", "WaitPartyPartner_agent_gender_1", "WaitPartyPartner_agent_gender_2"];


  keySend: string = '';
  contractFileInfo: ContractFileInfo = new ContractFileInfo();
  contractEncode = new ContractEncode();

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private partnerService: PartnerService,
    private auth: AuthService,
    private aasAuth: AasAuthService,
    private modalService: NgbModal,
    private contractService: AasContractService,
    private alert: AlertControl,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.makeFormSearch();
    this.makeDenyForm();
    this.loadPage(1);
  }

  /**
   * Khoi tao form tim kiem
   */
  makeFormSearch() {
    this.searchForm = this.fb.group({
      searchInput: ['']
    });
  }

  /**
   * Khoi tao form tu choi
   */
  makeDenyForm() {
    this.denyForm = new FormGroup({
        denyReason: new FormControl(null, [Validators.required]),
    });
  }

  get searchString() {
    return this.searchForm.value.searchInput;
  }
  

  /**
   * Tim kiem
   * @param value 
   */
  searchData(value) {
    this.loadPage(1);
  }

  /**
   * Tai trang
   * @param page 
   */
  loadPage(page) {
    this.page = page;
    this.getListPartnerVerification(this.verificationStatus, this.searchString, this.maxSize, page, this.userType);
  }

  /**
   * Xem chi tiet
   * @param id 
   */
  selectPartner(id) {
    this.partnerVerificationId = id;
    this.getDetailBusinessPartner(id);
  }

  reload() {
    this.page = 1;
    this.partner = new PartnerBusiness();
    this.loadPage(this.page);
  }

  actDownloadGPKD(id) {
    this.downloadGPKD(id);
  }

  handleClosePreview() {
    this.showPreviewGPKD = false;
  }

  // //MARK: Popup thông báo
  // alert(msg, type, twoBtn = false, iconBtn2 = '', titleBtn2 = ConstantAlertBtn.OK, actBtn2 = () => { }, iconBtn1 = '', titleBtn1 = ConstantAlertBtn.CANCEL, actBtn1 = () => { }) {
  //   const modalRef = this.modalService.open(AlertComponent);
  //   modalRef.componentInstance.message = msg;
  //   modalRef.componentInstance.typeAlert = type;
  //   modalRef.componentInstance.twoBtn = twoBtn;
  //   modalRef.componentInstance.iconBtn1 = iconBtn1;
  //   modalRef.componentInstance.iconBtn2 = iconBtn2;
  //   modalRef.componentInstance.titleButton1 = titleBtn1;
  //   modalRef.componentInstance.titleButton2 = titleBtn2;
  //   modalRef.componentInstance.callback1 = actBtn1;
  //   modalRef.componentInstance.callback2 = actBtn2;
  // }

  // //MARK: Handle Error
  // handleError(err, errorMsg) {
  //   if (err.error && err.error.message && errorMsg[err.error.message]) {
  //     this.alert(errorMsg[err.error.message], ConstantAlertType.ERROR);
  //   } else if (err.error && err.error.error) {
  //     this.alert(err.error.error, ConstantAlertType.ERROR);
  //   } else {
  //     this.alert(ConstantAlertMsg.DEFAULT_ERROR_REQUEST, ConstantAlertType.ERROR);
  //   }
  // }

  //MARK: NETWORKING
  /**
   * Lay danh sach doi tac cho xac minh
   * @param verificationStatus 
   * @param searchString 
   * @param maxSize 
   * @param page 
   * @param userType 
   */
  getListPartnerVerification(verificationStatus, searchString = '', maxSize = 10, page = 10, userType = 'CONSUMER') {
    this.partnerService.getListPartnerVerification(verificationStatus, searchString, maxSize, page, userType).subscribe((res: any) => {
      let result = new ListPartnerBusinessVerification(res.object || {});
      this.totalElement = result.totalElement;
      this.partners = result.data;

      if (this.partners.length > 0) this.selectPartner(this.partners[0].partnerVerificationId);
    }, err => {

    });
  }

  /**
   * Lay thong tin chi tiet doi tac
   * @param id 
   */
  getDetailBusinessPartner(id) {
    this.partnerService.getDetailBusinessPartner(id).subscribe((res: any) => {
      this.partner = new PartnerBusiness(res.object || {});
    }, err => {

    })
  }

  /**
   * Tai file GPKD
   * @param partyId 
   */
  downloadGPKD(partyId) {
    this.partnerService.downloadGPKD(partyId).subscribe((res: any) => {
      this.fileGPKD = new Blob([res], { type: 'application/pdf' });
      this.showPreviewGPKD = true;
    }, err => {

    })
  }

    // Download Contract
    hasDecode(contractId) {
      return this.contractEncode.hasDecode(contractId);
    } 
  
    getFileContract(id, status) {
      if (status === 'LC_CONTRACT_VALID') {
        if (this.hasDecode(id)) {
          this.getContractFileInfoDownload(id, 'CONTRACT', id);
        } else {
          this.alert.showAlert(this.translate.instant('WaitPartyPartner_note_1'), ConstantAlertType.BLANK, true, "", this.translate.instant('ServiceContractDetail_downloadContract'), () => {
            this.downloadEnCodeFile(id);
          }, "", this.translate.instant('btn_cancel'), null, this.translate.instant('ServiceContractDetail_confirmDownloadContract'));
        }
      } else {
        this.getContractFileInfoDownload(id, 'DRAFT', id);
      }
    }
  
    downloadEnCodeFile(contractId) {
      this.contractService.downloadEncodeContract(contractId).subscribe((res) => {
        const blob: any = new Blob([res], { type: 'application/pdf' });
        var url = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.download = `${contractId}.pdf`;
        anchor.href = url;
        anchor.click();
      }, err => {
        console.log(err);
        this.alert.showErrorHandled(err);
      })
    }
     /**
   * Lay thogn tin file hop dong
   * @param id 
   * @param type 
   * @param fileKey 
   */
      getContractFileInfoDownload(id, type, fileKey) {
        this.contractService.getContractFileInfo(id, type, fileKey).subscribe((res: any) => {
          this.contractFileInfo = new ContractFileInfo(res.object);
          this.keySend = this.contractFileInfo.keySend;
    
          this.downloadContractFileByUrlForSave(this.contractFileInfo.url, type, this.keySend, id);
        }, err => {
          console.log(err);
          this.alert.showErrorHandled(err);
        })
      }
  
    /**
     * Tai file hop dong tu url
     * @param url 
     */
     downloadContractFileByUrlForSave(url, type, keySend, id) {
      this.contractService.downloadContractFileByUrl(url).subscribe((res: any) => {
        const blob: any = new Blob([res]);
  
        if (keySend) {
          //Neu ton tai keySend
          //Tien hanh giai ma
          let secretKey = EncodeService.rsa.decrypt(this.auth.key, this.keySend);
          this.loadFileForSave(secretKey, blob, id);
        } else {
          //Neu khong ton tai keySend
          //Tien hanh luu file file PDF
          var url = window.URL.createObjectURL(blob);
          var anchor = document.createElement("a");
          anchor.download = `${id}.pdf`;
          anchor.href = url;
          anchor.click();
        }
      }, err => {
        console.log(err);
        this.alert.showErrorHandled(err);
      })
    }
  
     /**
   * Giai ma file
   * @param secretKey 
   * @param fileEncoded 
   */
      loadFileForSave(secretKey, fileEncoded, id) {
        var self = this;
        var reader = new FileReader();
        reader.onload = function () {
          var result: any = reader.result;
          var _base64DecodeRes = Buffer.from(result, 'base64');
          var iv = _base64DecodeRes.slice(0, 16);
          var dataEncrypt = _base64DecodeRes.slice(16, _base64DecodeRes.byteLength);
    
          // console.log(result, result.slice(0, 16));
          var typedArray = EncodeService.aes.decrypt(dataEncrypt, secretKey, iv);
    
          const bufferpdf = Buffer.from(typedArray);
          const blob: any = new Blob([bufferpdf], { type: 'application/pdf' });
          var url = window.URL.createObjectURL(blob);
          var anchor = document.createElement("a");
          anchor.download = `${id}.pdf`;
          anchor.href = url;
          anchor.click();
        }
        reader.readAsText(fileEncoded);
      }

      detailContract(contractId) {
        this.router.navigate([`/app/console/contract/${contractId}`]);
      }
}
